<template>
    <path d="M19.29 18.87c-.44-.1-.77-.42-.77-.71l.26-1.65.26-1.55-.12-.11a1.15 1.15 0 0 1-.24-1.45c.03-.07.14-.2.24-.28l.18-.17v-1.33l-.01-1.34-3.42.95c-1.91.53-3.5.96-3.62.97l-.2.03-5.3-1.47a623.8 623.8 0 0 0-5.41-1.5.66.66 0 0 1-.4-.2c-.29-.34-.08-.9.35-.96.05 0 2.53-.69 5.5-1.51L12 5.09l5.37 1.49c2.96.82 5.41 1.5 5.46 1.49.08 0 .3.08.38.15.08.07.16.24.18.36.03.18-.04.34-.18.49-.1.1-.16.13-.3.16l-1.38.37-1.22.34-.01 1.52V13l.1.07c.06.04.16.14.22.22.37.46.32 1.11-.13 1.53l-.15.14.27 1.62.27 1.62-.05.13c-.17.44-.9.7-1.54.55zm-8-.77c-1.82-.08-3.49-.52-4.42-1.17-.28-.19-.57-.5-.68-.73L6.1 16V13.9l-.01-2.12.06.02 2.88.8c2.22.63 2.84.8 2.97.8.13 0 .76-.17 3.02-.8 1.57-.45 2.87-.8 2.87-.8l.01 2.1v2.12l-.1.19c-.1.2-.38.52-.63.7-.95.68-2.58 1.11-4.53 1.2-.63.04-.7.04-1.35 0z"/>
</template>

<script>
    export default {
        name: 'qualification',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Qualification.vue